import {Spin} from "antd";
import React from "$react";

export default function AntDSpinLayout({spinning,...props}){
    return <Spin
        spinning = {spinning}
        {...props}
    />
}